/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BillingDemoDetails,
  BillingDetails,
  CheckoutRequest,
  MeteredUsage,
  MeteredUsageInput,
  ProductWithMetadata,
} from '../models/index';
import {
    BillingDemoDetailsFromJSON,
    BillingDemoDetailsToJSON,
    BillingDetailsFromJSON,
    BillingDetailsToJSON,
    CheckoutRequestFromJSON,
    CheckoutRequestToJSON,
    MeteredUsageFromJSON,
    MeteredUsageToJSON,
    MeteredUsageInputFromJSON,
    MeteredUsageInputToJSON,
    ProductWithMetadataFromJSON,
    ProductWithMetadataToJSON,
} from '../models/index';

export interface SubscriptionBillingRetrieveRequest {
    teamSlug: string;
}

export interface SubscriptionCheckoutCreateRequest {
    teamSlug: string;
    checkoutRequest: CheckoutRequest;
}

export interface SubscriptionDemoRetrieveRequest {
    teamSlug: string;
}

export interface SubscriptionPortalCreateRequest {
    teamSlug: string;
}

export interface SubscriptionUsageCreateRequest {
    teamSlug: string;
    meteredUsageInput: MeteredUsageInput;
}

/**
 *
 */
export class SubscriptionsApi extends runtime.BaseAPI {

    /**
     */
    async subscriptionBillingRetrieveRaw(requestParameters: SubscriptionBillingRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subscriptionBillingRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{team_slug}/subscription/api/billing/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionBillingRetrieve(requestParameters: SubscriptionBillingRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingDetails> {
        const response = await this.subscriptionBillingRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionCheckoutCreateRaw(requestParameters: SubscriptionCheckoutCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subscriptionCheckoutCreate().'
            );
        }

        if (requestParameters['checkoutRequest'] == null) {
            throw new runtime.RequiredError(
                'checkoutRequest',
                'Required parameter "checkoutRequest" was null or undefined when calling subscriptionCheckoutCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{team_slug}/subscription/stripe/api/create-checkout-session/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckoutRequestToJSON(requestParameters['checkoutRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async subscriptionCheckoutCreate(requestParameters: SubscriptionCheckoutCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.subscriptionCheckoutCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionDemoRetrieveRaw(requestParameters: SubscriptionDemoRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingDemoDetails>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subscriptionDemoRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{team_slug}/subscription/api/demo/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDemoDetailsFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionDemoRetrieve(requestParameters: SubscriptionDemoRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingDemoDetails> {
        const response = await this.subscriptionDemoRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionPortalCreateRaw(requestParameters: SubscriptionPortalCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subscriptionPortalCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{team_slug}/subscription/stripe/api/create-portal-session/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async subscriptionPortalCreate(requestParameters: SubscriptionPortalCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.subscriptionPortalCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionProductsListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductWithMetadata>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/subscriptions/api/active-products/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductWithMetadataFromJSON));
    }

    /**
     */
    async subscriptionProductsList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductWithMetadata>> {
        const response = await this.subscriptionProductsListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionUsageCreateRaw(requestParameters: SubscriptionUsageCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeteredUsage>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subscriptionUsageCreate().'
            );
        }

        if (requestParameters['meteredUsageInput'] == null) {
            throw new runtime.RequiredError(
                'meteredUsageInput',
                'Required parameter "meteredUsageInput" was null or undefined when calling subscriptionUsageCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{team_slug}/subscription/api/usage/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeteredUsageInputToJSON(requestParameters['meteredUsageInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeteredUsageFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionUsageCreate(requestParameters: SubscriptionUsageCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeteredUsage> {
        const response = await this.subscriptionUsageCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
